import React from "react";
import './App.css';
import NavMain from "./NavMain.js";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Gallery from "./Gallery.js";
import Custom from "./Custom.js";
import Custom2 from "./Custom2.js";
import Custom3 from "./Custom3.js";
import Custom4 from "./Custom4.js";
import Custom5 from "./Custom5.js";
import Custom6 from "./Custom6.js";
import Custom7 from "./Custom7.js";
import Videos from "./Videos.js";
import Techniques from "./Techniques.js";
import Bio from "./Bio.js";
import Contact from "./Contact.js";

class App extends React.Component {
  
  render() {
    return (
      <Router>
        <div className="App">
          <header className="App-header">
            <NavMain />
          </header>
          <div>
            <Switch>
              <Route path="/" exact component={Gallery} />
              <Route path="/custom" component={Custom} />
              <Route path="/custom2" component={Custom2} />
              <Route path="/custom3" component={Custom3} />
              <Route path="/custom4" component={Custom4} />
              <Route path="/custom5" component={Custom5} />
              <Route path="/custom6" component={Custom6} />
              <Route path="/custom7" component={Custom7} />
              <Route path="/videos" exact component={Videos} />
              <Route path="/techniques" exact component={Techniques} />
              <Route path="/bio" exact component={Bio} />
              <Route path="/contact" exact component={Contact} />
            </Switch>
            <footer id="logoBox">
                <img src="./images/misc/binghamIcon.jpg" alt="Artist in exhibition booth." className="artistImage" />
            </footer>
          </div>
        </div>
      </Router>
    );
  }
}


export default App;
